import { Pipe, PipeTransform } from '@angular/core';

import {convertOnlyDateFromUTCToUserTimezoneTEXT} from '../../base-functions/as-timezones.base-function';

@Pipe({ name: 'acOnlyDatePIPE' })
export class OnlyDatePipeAC implements PipeTransform {
    transform(value: any): String {
        return convertOnlyDateFromUTCToUserTimezoneTEXT(value);
    }
}